import React, { useContext } from "react"
import { Link } from "react-scroll";
import s from "./specialCalcLink.module.css"
import { NavContext } from "../context/NavState";


const SpecialCalcLink = () => {
    const {navigation} = useContext(NavContext)
    return (
        navigation.some(el => el.to === "calculator") ? <div className={s.container}>
            <div className={s.inner}>
                Не хотите ждать? Рассчитайте свой заказ сами за 1 минуту в
            </div>
            <Link className={s.link} to={"calculator"} offset={-65} smooth={true} duration={800}>
                онлайн-калькуляторе
            </Link>
        </div> : <></>
    );
}

export default SpecialCalcLink;
